
import React from 'react';
import {FlowRender} from "../flow-render";
import {CLIENT_SIGNER} from "../onboarding-utils";

const WIDTH = "75%";

class OnboardingEnd extends FlowRender {
  constructor(index) {
    super(index, []);
  }

  onSign = component => () => {
    component.docusign_processing = true;
    component.setState(component.state);
    component.beginSigning(CLIENT_SIGNER, true);
  }

  renderNavButtons  = component => {
    const WIDTH = "75%";
    const container_style = {
      width: WIDTH,
      margin: "auto",
      display: "flex",
      justifyContent: "center",
    }

    const is_processing = component.docusign_processing;
    const is_navigating = component.navigating_to_docusign;
    let msg;

    if (is_processing) {
      msg = (
        <div align={"center"}>
          Generating Electronic Documents
        </div>
      )
    } else if (is_navigating) {
      msg = (
        <div align={"center"}>
          Navigating to Docusign
        </div>
      )
    }

    const show_back_button = !is_processing && !is_navigating;

    return (
      <div>
        <div style={container_style}>
          <div>
            { show_back_button && this.renderNextButton(component, null, true) }
            { !is_navigating && this.renderButton(
              component, "Sign Documents", component.docusign_processing,
              this.onSign(component))}
          </div>
        </div>
        { msg }
      </div>

    )
  }

  render = component => {
    const container_style = {
      width: WIDTH,
      margin: "auto",
    }

    return (
      <div>
        {this.renderTitle(component, "Onboarding Complete", WIDTH)}
        { this.renderProgress(component, WIDTH) }
        <section className={"section"}>
          <div style={container_style}>
            <div>
              Docusign Signing below
            </div>
            <div style={{height: "4rem"}}/>
            { this.renderNavButtons(component) }
          </div>
        </section>
      </div>
    )
  }
}

export { OnboardingEnd };
